
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const Messages = namespace('messages')
const Viewport = namespace('viewport')

@Component
export default class NewMessagesBadge extends Vue {
	@Messages.State('newCount')
	allNewMessagesCount

	@Messages.State('newTransportsMessagesCount')
	newTransportsMessages

	@Messages.State('newOffersMessagesCount')
	newOffersMessages

	@Messages.State('newEmptyReportMessagesCount')
	newEmptyReportMessages

	@Messages.State('newCargoReportMessagesCount')
	newCargoReportMessages

	@Messages.State('newFleetInvitationsCount')
	newFleetInvitations

	@Messages.State('newSharedEmptyReportsCount')
	newSharedEmptyReports!: number

	@Messages.State('newSharedCargoReportsCount')
	newSharedCargoReports!: number

	@Viewport.Getter('isMobile')
	isMobile!: boolean

	@Prop({ default: '' })
	navigationItemSlug!: string

	@Prop({ default: 0 })
	newMessagesAmount!: number | null

	@Prop({ default: 'alertNavBar' })
	displayStyle!: string

	newMessages: number = 0

	async created() {
		this.setNewMessages()
	}

	setNewMessages() {
		if (this.navigationItemSlug === 'message') {
			this.newMessages = this.allNewMessagesCount
		} else if (this.navigationItemSlug === 'cargo') {
			this.newMessages = this.newOffersMessages
		} else if (this.navigationItemSlug === 'transport') {
			this.newMessages = this.newTransportsMessages
		} else if (this.navigationItemSlug === 'group') {
			this.newMessages = this.newFleetInvitations
		} else if (this.navigationItemSlug === 'capacity-radar') {
			this.newMessages = this.newEmptyReportMessages
		} else if (this.navigationItemSlug === 'cargo-radar') {
			this.newMessages = this.newCargoReportMessages
		} else if (this.navigationItemSlug === 'radar') {
			this.newMessages = this.newEmptyReportMessages + this.newCargoReportMessages
		}

		if (!this.navigationItemSlug) {
			this.newMessages = this.newMessagesAmount ?? 0
		}
	}

	get showBadgeAtNavigationItem() {
		return ['message', 'cargo', 'transport', 'group', 'capacity-radar', 'cargo-radar', 'radar'].includes(
			this.navigationItemSlug
		)
	}

	@Watch('allNewMessagesCount')
	syncAllMessages() {
		this.setNewMessages()
	}

	@Watch('newOffersMessages')
	syncOfferMessages() {
		this.setNewMessages()
	}

	@Watch('newEmptyReportMessages')
	syncEmptyReportMessages() {
		this.setNewMessages()
	}

	@Watch('newCargoReportMessages')
	syncCargoReportMessages() {
		this.setNewMessages()
	}

	@Watch('newTransportsMessages')
	syncTransportMessages() {
		this.setNewMessages()
	}

	@Watch('newFleetInvitations')
	syncFleetInvitations() {
		this.setNewMessages()
	}

	get showSharedReportsBadge(): boolean {
		return (
			(this.navigationItemSlug === 'capacity-radar' && this.newSharedEmptyReports > 0) ||
			(this.navigationItemSlug === 'cargo-radar' && this.newSharedCargoReports > 0) ||
			(this.navigationItemSlug === 'radar' && this.newSharedEmptyReports + this.newSharedCargoReports > 0)
		)
	}

	get sharedReportsBadgeCount(): number {
		if (this.navigationItemSlug === 'capacity-radar') {
			return this.newSharedEmptyReports
		} else if (this.navigationItemSlug === 'cargo-radar') {
			return this.newSharedCargoReports
		} else if (this.navigationItemSlug === 'radar') {
			return this.newSharedEmptyReports + this.newSharedCargoReports
		}
		return 0
	}
}
